import { memo } from 'react';

import { ArchiveIcon, EllipsisIcon, ExternalLinkIcon } from '@air/design-icons';
import { DropdownMenu, DropdownMenuItem } from '@air/primitive-dropdown-menu';
import { IconButton } from '@air/primitive-icon-button';

export type WorkspaceAgentPanelMyTasksRowOverflowMenuProps = {
  isArchiveDisabled: boolean;
  onArchive: () => void;
  onOpen: () => void;
  sessionTitle: string;
  showArchive: boolean;
};

export const WorkspaceAgentPanelMyTasksRowOverflowMenu = memo(
  ({
    isArchiveDisabled,
    onArchive,
    onOpen,
    sessionTitle,
    showArchive,
  }: WorkspaceAgentPanelMyTasksRowOverflowMenuProps) => {
    const overflowLabel = `Options for ${sessionTitle}`;

    return (
      <div className="pointer-events-none absolute top-2 right-2 opacity-0 transition-opacity group-focus-within:pointer-events-auto group-focus-within:opacity-100 group-hover:pointer-events-auto group-hover:opacity-100">
        <DropdownMenu
          align="end"
          sideOffset={4}
          trigger={
            <IconButton
              adsIcon
              appearance="ghost"
              color="gray"
              data-testid="WORKSPACE_AGENT_PANEL_MY_TASKS_ROW_OVERFLOW_TRIGGER"
              label={overflowLabel}
              size="small"
              type="button"
              icon={EllipsisIcon}
            />
          }
          triggerTooltip={overflowLabel}
        >
          <DropdownMenuItem
            data-testid="WORKSPACE_AGENT_PANEL_MY_TASKS_ROW_OPEN_TASK"
            label="Open task"
            onSelect={onOpen}
            prefix={<ExternalLinkIcon aria-hidden className="ads:text-icon-subtle text-gray-9" size="sm" />}
          />
          {showArchive ? (
            <DropdownMenuItem
              data-testid="WORKSPACE_AGENT_PANEL_MY_TASKS_ROW_ARCHIVE_TASK"
              disabled={isArchiveDisabled}
              label="Archive task"
              onSelect={onArchive}
              prefix={<ArchiveIcon aria-hidden className="ads:text-icon-subtle text-gray-9" size="sm" />}
            />
          ) : null}
        </DropdownMenu>
      </div>
    );
  },
);

WorkspaceAgentPanelMyTasksRowOverflowMenu.displayName = 'WorkspaceAgentPanelMyTasksRowOverflowMenu';
